// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2ctJoZEQdOiDDopEkfY3D0","icon":"_1mhsFjItzw0xe1rt-7nCRO"};